import { gql } from "@apollo/client";

export enum CONNECTION_TYPES {
    SERVICE7000 = 4,
    YAROWA = 5,
    NONE = 0
}

export enum NOTIFICATION_TYPES {
    DAMAGE_NOTIFICATION = 2,
    UNDEFINED = 0
}

export interface Notification {
    version: string | null;
    type: number;
    forwardingtype?: CONNECTION_TYPES;
    location?: Location;
    damage?: Damage;
    contactperson?: Person;
    nameplate?: Nameplate;
    key?: Key;
    message?: string;
    documentimage?: NotificationImage;
    componentid?: string;
    component?: string;
    language?: string;
    directsendready: boolean;
    abortdirectsend: boolean;
}

export interface Nameplate {
    inscription: string;
    belldifferent: boolean;
    bellinscription: string;
    mailboxdifferent: boolean;
    mailboxinscription: string;
    doordifferent: boolean;
    doorinscription: string;
}

export interface Key {
    amount: number;
    inscription: string;
    lost: boolean;
    keyimage1?: NotificationImage;
    keyimage2?: NotificationImage;
}

export interface Person {
    id?: string;
    salutation?: string;
    name1?: string;
    name2?: string;
    email?: string;
    mobile?: string;
    reachability?: { from: string; to: string }[];
    gender?: number;
}

export interface Location {
    zip: string;
    city: string;
    street: string;
    number: string;
    floor: string;
}

export interface Damage {
    manufacturer?: string;
    serialnumber?: string;
    description?: string;
    image1?: NotificationImage;
    image2?: NotificationImage;
    serialnumberimage?: NotificationImage;
    roomtype?: number;
    appliancetype?: number;
}

export interface NotificationImage {
    id: string;
    name: string;
    url?: string;
    type: string;
    image?: string; // base64-image
    mimetype?: string;
}

export enum IMAGE_TYPE {
    DAMAGE = 501,
    SERIALNUMBER = 502,
    PRODUCTIONNUMBER = 503,
    KEY = 504,
    DOCUMENT = 505
}

export enum GENDER {
    LEGAL_PERSON = 0,
    MALE = 1,
    FEMALE = 2,
    NEUTRAL = 3
}

export const SUBSCRIBE_TO_NOTIFICATION_STATE = gql`
    subscription SubscribeToNotificationState($id: uuid!) {
        ec_notifications(where: { _and: { id: { _eq: $id }, state: { _gte: 5 } } }) {
            customerid
            id
            state
        }
    }
`;
